/* =========================================================
 * Masterpiece Mirrors — Custom Cut-to-Size Landing Page
 * Calculator + FAQ accordion.
 *
 * Pricing rates and the minimum price are read from data-*
 * attributes on #mirror-calculator, which are populated by
 * the section schema in sections/static-custom-mirror.liquid.
 * ========================================================= */
(function () {
  function init() {
    initCalculator();
    initFaqAccordion();
  }

  /* -------------------- Price Calculator -------------------- */
  function initCalculator() {
    var calculator = document.getElementById('mirror-calculator');
    if (!calculator) return;

    var widthInput        = document.getElementById('width');
    var heightInput       = document.getElementById('height');
    var edgeSelector      = document.getElementById('edge-selector');
    var thicknessInput    = document.getElementById('thickness');
    var priceDisplay      = document.getElementById('estimated-price');
    var mirrorTypeNote    = document.getElementById('mirror-type-note');
    var mirrorTypeSelector = document.getElementById('mirror-type-selector');
    var vinylSelector     = document.getElementById('vinyl-selector');

    // Inputs on the quote-request form further down the page
    var quoteWidth       = document.getElementById('quote-width');
    var quoteHeight      = document.getElementById('quote-height');
    var quoteEdge        = document.getElementById('quote-edge');
    var quoteMirrorType  = document.getElementById('quote-mirror-type');

    // Pricing rates (per square metre, inc. GST) — injected from schema.
    // NOTE: Attribute names avoid hyphen-before-digit (e.g. data-rate-silver4,
    // not data-rate-silver-4mm) because the HTML5 dataset API only collapses
    // `-` + lowercase-letter into camelCase, so `-4` would survive as a
    // literal hyphen in the key and the dot-accessor would return undefined.
    var RATES = {
      silver: {
        '4mm': parseFloat(calculator.dataset.rateSilver4) || 0,
        '6mm': parseFloat(calculator.dataset.rateSilver6) || 0
      },
      grey: {
        '4mm': parseFloat(calculator.dataset.rateGrey6) || 0,   // 4mm not offered; fallback to 6mm rate
        '6mm': parseFloat(calculator.dataset.rateGrey6) || 0
      },
      bronze: {
        '4mm': parseFloat(calculator.dataset.rateBronze6) || 0, // 4mm not offered; fallback to 6mm rate
        '6mm': parseFloat(calculator.dataset.rateBronze6) || 0
      }
    };
    var MINIMUM_PRICE = parseFloat(calculator.dataset.minimumPrice) || 0;
    var VINYL_RATE    = parseFloat(calculator.dataset.vinylRate) || 0;

    var selectedMirrorType = 'silver';
    var vinylBacking       = false;

    function calculatePrice() {
      var rate = RATES[selectedMirrorType][thicknessInput.value];
      var widthM  = parseFloat(widthInput.value) / 1000;
      var heightM = parseFloat(heightInput.value) / 1000;

      if (isNaN(widthM) || isNaN(heightM) || widthM <= 0 || heightM <= 0) {
        priceDisplay.textContent = '$0.00';
        return;
      }

      var area       = widthM * heightM;
      var mirrorCost = Math.max(area * rate, MINIMUM_PRICE);
      var vinylCost  = vinylBacking ? (area * VINYL_RATE) : 0;
      var total      = mirrorCost + vinylCost;

      priceDisplay.textContent = '$' + total.toFixed(2);

      // Sync values to the quote form
      if (quoteWidth)  quoteWidth.value  = widthInput.value;
      if (quoteHeight) quoteHeight.value = heightInput.value;
      if (quoteEdge) {
        quoteEdge.value = thicknessInput.value === '4mm' ? '4mm-polished' : '6mm-polished';
      }
    }

    // Grey / bronze are only available in 6mm — disable the 4mm option visually
    // in the calculator AND hide the corresponding option(s) in the quote form's
    // Edge Finish dropdown so a user can't submit an unbuildable combination.
    function updateThicknessForType(type) {
      var only6mm = (type === 'grey' || type === 'bronze');

      var opt4mm = edgeSelector.querySelector('[data-value="4mm"]');
      var opt6mm = edgeSelector.querySelector('[data-value="6mm"]');
      if (opt4mm && opt6mm) {
        if (only6mm) {
          opt4mm.style.opacity = '0.35';
          opt4mm.style.pointerEvents = 'none';
          opt4mm.classList.remove('selected');
          opt6mm.classList.add('selected');
          thicknessInput.value = '6mm';
        } else {
          opt4mm.style.opacity = '1';
          opt4mm.style.pointerEvents = '';
        }
      }

      // Filter the quote form's Edge Finish dropdown.
      if (quoteEdge) {
        var quote4mm = quoteEdge.querySelector('option[value="4mm-polished"]');
        if (quote4mm) {
          quote4mm.hidden = only6mm;
          quote4mm.disabled = only6mm;
        }
        if (only6mm && quoteEdge.value === '4mm-polished') {
          quoteEdge.value = '6mm-polished';
        }
      }
    }

    // Mirror-type chip selector
    if (mirrorTypeSelector) {
      mirrorTypeSelector.addEventListener('click', function (e) {
        var chip = e.target.closest('.mirror-chip');
        if (!chip) return;
        mirrorTypeSelector.querySelectorAll('.mirror-chip').forEach(function (c) {
          c.classList.remove('selected');
        });
        chip.classList.add('selected');
        selectedMirrorType = chip.dataset.type;
        if (mirrorTypeNote) mirrorTypeNote.textContent = '';
        if (quoteMirrorType) quoteMirrorType.value = selectedMirrorType;
        updateThicknessForType(selectedMirrorType);
        calculatePrice();
      });
    }

    // Vinyl-backing chip selector
    if (vinylSelector) {
      vinylSelector.addEventListener('click', function (e) {
        var chip = e.target.closest('.mirror-chip');
        if (!chip) return;
        vinylSelector.querySelectorAll('.mirror-chip').forEach(function (c) {
          c.classList.remove('selected');
        });
        chip.classList.add('selected');
        vinylBacking = chip.dataset.vinyl === 'yes';
        calculatePrice();
      });
    }

    // Thickness (4mm / 6mm) selector
    if (edgeSelector) {
      edgeSelector.addEventListener('click', function (e) {
        var selectedOption = e.target.closest('.edge-option');
        if (!selectedOption) return;
        edgeSelector.querySelectorAll('.edge-option').forEach(function (opt) {
          opt.classList.remove('selected');
        });
        selectedOption.classList.add('selected');
        thicknessInput.value = selectedOption.dataset.value;
        calculatePrice();
      });
    }

    [widthInput, heightInput].forEach(function (el) {
      if (el) el.addEventListener('input', calculatePrice);
    });
  }

  /* -------------------- FAQ Accordion -------------------- */
  function initFaqAccordion() {
    var faqContainer = document.getElementById('faq-container');
    if (!faqContainer) return;

    faqContainer.addEventListener('click', function (e) {
      var questionButton = e.target.closest('.faq-question');
      if (!questionButton) return;

      var item   = questionButton.parentElement;
      var answer = item.querySelector('.faq-answer');
      var arrow  = questionButton.querySelector('.faq-arrow');
      var isOpening = !answer.style.maxHeight || answer.style.maxHeight === '0px';

      // Close all other items first
      faqContainer.querySelectorAll('.faq-item').forEach(function (otherItem) {
        if (otherItem !== item) {
          var otherAnswer = otherItem.querySelector('.faq-answer');
          var otherArrow  = otherItem.querySelector('.faq-arrow');
          otherAnswer.style.maxHeight     = '0px';
          otherAnswer.style.paddingTop    = '0';
          otherAnswer.style.paddingBottom = '0';
          if (otherArrow) otherArrow.classList.remove('rotate-180');
        }
      });

      // Toggle the clicked item
      if (isOpening) {
        answer.style.maxHeight     = answer.scrollHeight + 'px';
        answer.style.paddingTop    = '0';
        answer.style.paddingBottom = '1.5rem';
        if (arrow) arrow.classList.add('rotate-180');
      } else {
        answer.style.maxHeight     = '0px';
        answer.style.paddingTop    = '0';
        answer.style.paddingBottom = '0';
        if (arrow) arrow.classList.remove('rotate-180');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();